import * as React from "react";

function BasicInformation(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 29 29" fill="none" {...props}>
      <path
        d="M12.044 27.417c-5.324 0-7.986 0-9.64-1.562C.75 24.292.75 21.778.75 16.75v-5.333c0-5.029 0-7.543 1.654-9.105C4.058.75 6.72.75 12.044.75h1.412c5.324 0 7.986 0 9.64 1.562 1.654 1.562 1.654 4.076 1.654 9.105M7.416 7.418h10.667M7.416 14.084h8"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M16.75 27.418c2.451-3.664 8.158-3.864 10.667 0M24.75 17.99c0 1.42-1.194 2.571-2.667 2.571-1.472 0-2.666-1.151-2.666-2.572 0-1.42 1.194-2.571 2.666-2.571 1.473 0 2.667 1.151 2.667 2.572z"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default BasicInformation;
